<template>
  <div class="ma-3">
    <h1 style="font-size: xx-large;margin-top: 80px; line-height: 35px; font-weight: bold;"
      :style="{ color: $ajustes.colorTexto2 }">CONTACTANOS</h1>
    <h1 style="font-size:large; line-height: 35px; font-weight: normal;" :style="{ color: $ajustes.colorTexto2 }">
      Pregunta sobre nuestros cursos</h1>
    <v-row class="pt-2 " v-if="!cargando">
      <v-col class="ma-0 pa-2" lg="4" md="4" sm="6" cols="12">
        <v-container>
          <h1 style="text-align: justify; line-height: 20px; font-size: 15pt;">Información Institucional</h1>
          <span class="mt-2" style="font-size: small;"><strong>Dirección: </strong> {{ instituto.direccion }}</span>
          <span class="mt-2" style="font-size: small;"><strong>Teléfono: </strong> {{ instituto.telefono }}</span>
          <span class="mt-2" style="font-size: small;"><strong>Email: </strong> {{ instituto.correo }}</span>
          <span class="mt-2" style="font-size: small;"><strong>Horario de atención: </strong><br> {{
            instituto.horario_dias }} <br> {{ instituto.horario_horas }} </span>
          <span class="mt-2" style="font-size: small;"><strong>Redes Sociales</strong>
            <br>
            <strong>
              <a :href="links.linkFacebook" target="_blank" rel="noopener" style="color: blue;">Facebook</a>
              |
              <a :href="links.linkInstagram" target="_blank" rel="noopener" style="color: blue;">Instragram</a>
              |
              <a :href="links.linkYoutube" target="_blank" rel="noopener" style="color: blue;">Youtube</a>
            </strong>
          </span>
        </v-container>
      </v-col>
      <v-col class="ma-0 pa-2" lg="4" md="4" sm="6" cols="12">
        <v-container>
          <h1 class="mb-3" style="text-align: justify; line-height: 20px; font-size: 15pt;">Envíanos un mensaje</h1>
          <formulario />
        </v-container>
      </v-col>
      <v-col class="ma-0 pa-2" lg="4" md="4" sm="6" cols="12">
        <v-container>
          <h1 style="text-align: justify; line-height: 20px; font-size: 15pt;">Enlaces Útiles</h1>
          <span class="mt-2" style="font-size: small;">
            <a @click="goto('Nosotros')" style="color: blue;text-decoration: underline">Acerca de la institución</a>
            <br>
            <a @click="goto('Cursos')" style="color: blue;text-decoration: underline">Oferta Académica</a>
            <br>
            <a href="https://aulavirtual.inseg.com.ec/" style="color: blue;text-decoration: underline">Acceso a
              Moodle</a>
            <br>
            <a @click="goto('Noticias')" style="color: blue;text-decoration: underline">Noticias y Eventos</a>
          </span>
          <br>
        </v-container>
        <v-container>
          <h1 style="text-align: justify; line-height: 20px; font-size: 15pt;">Accesibilidad</h1>
          <span class="mt-2 pr-5" style="font-size: small;">{{ instituto.accesibilidad }}</span>
          <br>
        </v-container>

      </v-col>

    </v-row>
    <h2 v-else class="center">
      <br>
      Cargando...
    </h2>
    <br>
  </div>
</template>



<script>
import formulario from "@/components/template/formulario";
import axios from 'axios';

export default {
  components: {
    formulario
  },
  metaInfo() {
    return {
      title: "Contactos",
      titleTemplate: "%s | INSEG",
      meta: [
        {
          name: "description",
          content: "Contacta con INSEG Ecuador para más información sobre formación técnica en Seguridad Global y Transporte, INSEG Ecuador. Teléfonos, emails y ubicaciones."
        }
      ]
    }
  },
  data() {
    return {
      showMenu: true,
      cargando: true,
      instituto: {
        direccion: ""
      },
      links: {
        linkFacebook: "", linkInstagram: "", linkYoutube: ""
      },
      show: {
        responsible: "",
      },

    };
  },
  mounted() {
    this.obtenerInstitutoDatos()
  },
  created() {

  },
  methods: {
    async obtenerInstitutoDatos() {
      await this.obtenerInstituto()
      await this.obtenerAjustes()
      this.cargando = false
    },
    async obtenerInstituto() {
      return await axios.get("/obtener_instituto")
        .then((response) => {
          if (response.data) {
            this.llenarDatosInstituto(response.data.data)
          } else {
            throw new Error(response.data.status);
          }
        })
        .catch((error) => {
          throw error;
        });
    },
    async obtenerAjustes() {
      return await axios.get("/obtener_ajustes")
        .then((response) => {
          if (response.data) {
            this.links.linkFacebook = response.data.data.linkFacebook
            this.links.linkInstagram = response.data.data.linkInstagram
            this.links.linkYoutube = response.data.data.linkYoutube
          } else {
            throw new Error(response.data.status);
          }
        })
        .catch((error) => {
          throw error;
        });
    },
    llenarDatosInstituto(aux) {
      this.instituto.accesibilidad = aux.accesibilidad;
      this.instituto.direccion = aux.direccion;
      this.instituto.telefono = aux.telefono;
      this.instituto.correo = aux.correo;
      this.instituto.horario_dias = aux.horario_dias;
      this.instituto.horario_horas = aux.horario_horas;
    },

  },
  computed: {
  },
  beforeDestroy() {
  },
};
</script>

<style scoped>
.centered-input>>>input {
  text-align: center;
}
</style>